import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CourierReturnStatusType,
  CourierViewType,
  ICourier,
  useCouriersActions,
} from '../../context/couriers';
import IconButton from '@material-ui/core/IconButton';
import useStyles from './styles';
import { Typography, useTheme } from '@material-ui/core';
import {
  DeliveryMenuNavigationItem,
  useDeliveryNavigationActions,
} from '../../context/delivery-navigation';
import {  parseGuestName } from '@src/shared/utils';

interface ICourierListItemProps extends ICourier {
  viewType?: CourierViewType;
  assignedCourierId?: string;
  hash?: string;
  orderId?: string;
  currentOrderStatus?: OrderStatus;
  hasAlcohol?: boolean;
}

export enum POPUP_TYPE_ORDER {
  ASSIGN_ORDER = 'ASSIGN_ORDER',
  UNASSIGN_ORDER = 'UNASSIGN_ORDER',
  ASSIGN_ORDER_BAG = 'ASSIGN_ORDER_BAG',
  COURIER_INDELIVERY = 'COURIER_INDELIVERY',
  REASSIGN_ORDER = 'REASSIGN_ORDER',
}

type TActivePopupOrderAssign = {
  type: POPUP_TYPE_ORDER;
  isOpen: boolean;
  isPending: boolean;
  courierId: string;
  courierEmail: string;
  hash: string;
  variables: { [key: string]: any };
};

const initialActivePopupOrderAssign: TActivePopupOrderAssign = {
  type: POPUP_TYPE_ORDER.ASSIGN_ORDER,
  isOpen: false,
  isPending: false,
  courierId: '',
  courierEmail: '',
  hash: '',
  variables: {},
};

enum AssignationType {
  ASSIGN = 'ASSIGN',
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
  OVERVIEW = 'OVERVIEW',
  REASSIGN = 'REASSIGN',
}

import { getTimeFromDate } from '@shared/utils';
import Popup from '@src/shared/components/Popup';
import { useOrderMutationHandler } from '../../hooks/use-order-mutation-handler';
import { OrderStatus, useOrdersState } from '../../context/orders';
import { useMobileViewActions } from '@src/shared/context/mobile-view';
import i18n, { defaultLang } from '@src/i18n';
import {
  trackDeliveryDahsboardOnAssignOrderCancel,
  trackDeliveryDahsboardOnAssignOrderStart,
  trackDeliveryDashboardOnClickReAssignOrderCancel,
  trackDeliveryDashboardOnClickReAssignOrderStart,
  trackDeliveryDashboardOnClickRemoveOrderCancel,
  trackDeliveryDashboardOnClickRemoveOrderStart,
} from '../../tracking/delivery-dashboard';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import {
  EBadgeStatus,
  JetStatusBadge,
} from '@src/shared/components/JetStatusBadges';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import Card from '@src/shared/components/Card';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import useBackIn from '../../hooks/use-back-in';
import useFMFeatureFlag from '@src/shared/hooks/use-fm-featureflag';
import { JETFM_CRT_COUNTDOWN_FLAG } from '@src/shared/models';
const CourierListItem: FC<ICourierListItemProps> = ({
  firstName,
  id,
  orderPool,
  returnBack,
  backBy,
  isGuest,
  viewType,
  assignedCourierId,
  hash,
  orderId,
  hasAlcohol,
  vehicleType,
  currentOrderStatus,
}) => {
  const isCRTCountdownActive = useFMFeatureFlag(JETFM_CRT_COUNTDOWN_FLAG);
  const { t } = useTranslation();
  const classes = useStyles();
  const {getDistanceDuration} = useBackIn();
  const {
    handleAssignOrderMutation,
    handleUnAssignOrderMutation,
    isPromising,
    hasNextStep,
  } = useOrderMutationHandler();
  const [isInDelivery, setIsInDelivery] = useState(false);
  const { ordersById } = useOrdersState();
  const { restaurant } = useKeycloakUserState();
  const [activePopup, setActivePopup] = useState<TActivePopupOrderAssign>(
    initialActivePopupOrderAssign
  );
  const theme = useTheme();

  const { setOrderDetailMobileView } = useMobileViewActions();

  const { setSelectedCourierId } = useCouriersActions();
  const { isMobileDevice: isMobileScreen } = useDeviceDetect();
  const { setActiveMenu } = useDeliveryNavigationActions();
  const setSelectedCourier = (courierId: string) => {
    if (isMobileScreen) {
      setActiveMenu(DeliveryMenuNavigationItem.Map);
    }
    setSelectedCourierId(courierId);
  };

  const orderItemsCTA = (
    id: string,
    hash: string,
    assignationType: AssignationType
  ) => {
    let assignType = null;
    const commonTrackingData = {
      language: i18n.language || defaultLang,
      country: restaurant?.country || '',
      orderData: {
        order_action: '',
        order_id: orderId as string,
        order_alcohol: hasAlcohol ? true : false,
        order_hashed: hash || '',
        vehicleType: vehicleType,
      },
    };

    switch (assignationType) {
      case AssignationType.ASSIGN:
        // Assign Tracking
        trackDeliveryDahsboardOnAssignOrderStart({
          ...commonTrackingData,
          orderData: {
            ...commonTrackingData.orderData,
            order_action: 'single order assign start',
          },
        });
        assignType = POPUP_TYPE_ORDER.ASSIGN_ORDER;

        break;
      case AssignationType.UPDATE:
        if (currentOrderStatus === OrderStatus.Assigned) {
          trackDeliveryDashboardOnClickReAssignOrderStart({
            ...commonTrackingData,
            orderData: {
              ...commonTrackingData.orderData,
              order_action: 'single order reassign start',
            },
          });
        } else {
          trackDeliveryDahsboardOnAssignOrderStart({
            ...commonTrackingData,
            orderData: {
              ...commonTrackingData.orderData,
              order_action: 'single order assign start',
            },
          });
        }
        assignType = POPUP_TYPE_ORDER.ASSIGN_ORDER_BAG;

        break;
      case AssignationType.REMOVE:
        trackDeliveryDashboardOnClickRemoveOrderStart({
          ...commonTrackingData,
          orderData: {
            ...commonTrackingData.orderData,
            order_action: 'single order remove start',
          },
        });
        assignType = POPUP_TYPE_ORDER.UNASSIGN_ORDER;
        break;
      case AssignationType.REASSIGN:
        trackDeliveryDashboardOnClickReAssignOrderStart({
          ...commonTrackingData,
          orderData: {
            ...commonTrackingData.orderData,
            order_action: 'single order reassign start',
          },
        });
        assignType = POPUP_TYPE_ORDER.REASSIGN_ORDER;
        break;
      case AssignationType.OVERVIEW:
        assignType = POPUP_TYPE_ORDER.COURIER_INDELIVERY;
        break;
    }

    setActivePopup({
      ...initialActivePopupOrderAssign,
      type: assignType as POPUP_TYPE_ORDER,
      isOpen: true,
      courierId: id,
      hash,
      variables: {
        showNextStep: assignationType === AssignationType.UPDATE ? true : false,
        courierName: firstName,
        orderId,
        hasAlcohol,
        vehicleType,
        assignType,
        isOrderAssigned: currentOrderStatus === OrderStatus.Assigned,
      },
    });
  };

  const closeActivePopup = (ignoreTracking: boolean = false) => {
    const commonTrackingData = {
      language: i18n.language || defaultLang,
      country: restaurant?.country || '',
      orderData: {
        order_action: '',
        order_id: activePopup.variables.orderId,
        order_alcohol: activePopup.variables.hasAlcohol ? true : false,
        order_hashed: activePopup.hash || '',
        courier_vehicle: activePopup.variables.vehicleType,
      },
    };

    if (activePopup.isOpen === true && typeof ignoreTracking === 'object') {
      switch (activePopup.type) {
        case POPUP_TYPE_ORDER.ASSIGN_ORDER:
          trackDeliveryDahsboardOnAssignOrderCancel({
            ...commonTrackingData,
            orderData: {
              ...commonTrackingData.orderData,
              order_action: 'single order assign cancel',
            },
          });
          break;
        case POPUP_TYPE_ORDER.UNASSIGN_ORDER:
          trackDeliveryDashboardOnClickRemoveOrderCancel({
            ...commonTrackingData,
            orderData: {
              ...commonTrackingData.orderData,
              order_action: 'single order remove cancel',
            },
          });
          break;
        case POPUP_TYPE_ORDER.ASSIGN_ORDER_BAG:
          if (currentOrderStatus === OrderStatus.Assigned) {
            trackDeliveryDashboardOnClickReAssignOrderCancel({
              ...commonTrackingData,
              orderData: {
                ...commonTrackingData.orderData,
                order_action: 'single order reassign cancel',
              },
            });
          } else {
            trackDeliveryDahsboardOnAssignOrderCancel({
              ...commonTrackingData,
              orderData: {
                ...commonTrackingData.orderData,
                order_action: 'single order assign cancel',
              },
            });
          }

          break;
        case POPUP_TYPE_ORDER.REASSIGN_ORDER:
          trackDeliveryDashboardOnClickReAssignOrderCancel({
            ...commonTrackingData,
            orderData: {
              ...commonTrackingData.orderData,
              order_action: 'single order reassign cancel',
            },
          });
          break;
      }
    }
    updateActivePopup('isOpen', false);
  };

  const handleInDeliveryMessage = async ({
    courierId,
  }: {
    courierId: string;
  }) => {
    if (isMobileScreen) {
      setOrderDetailMobileView(true);
    }
    setSelectedCourier(courierId);
  };

  const updateActivePopup = (prop: string, value: boolean) => {
    setActivePopup((state) => ({ ...state, [prop]: value }));
  };

  const [passedWaypointsCount, setPassedWaypointsCount] = useState<number>(0);
  useEffect(() => {
    if (orderPool) {
      setPassedWaypointsCount(
        orderPool?.route?.waypoints.filter(
          (order) => order.isDelivered === true
        ).length as number
      );

      orderPool?.route.waypoints.map((orderItems) => {
        if (
          ordersById[orderItems.order.uuid]?.status == OrderStatus.InDelivery
        ) {
          if (!isInDelivery) {
            setIsInDelivery(true);
          }
        }
      });
    }
  }, [orderPool]);

  useEffect(() => {
    if (isPromising) {
      updateActivePopup('isPending', true);
    }

    if (hasNextStep) {
      orderItemsCTA(
        activePopup.courierId,
        activePopup.hash,
        AssignationType.OVERVIEW
      );
    }
    return () => {
      updateActivePopup('isPending', false);
      closeActivePopup(true);
    };
  }, [isPromising, hasNextStep]);

  let popupConfirmationAction;
  switch (activePopup.type) {
    case POPUP_TYPE_ORDER.ASSIGN_ORDER:
      popupConfirmationAction = handleAssignOrderMutation;
      break;
    case POPUP_TYPE_ORDER.UNASSIGN_ORDER:
      popupConfirmationAction = handleUnAssignOrderMutation;
      break;
    case POPUP_TYPE_ORDER.ASSIGN_ORDER_BAG:
      popupConfirmationAction = handleAssignOrderMutation;
      break;
    case POPUP_TYPE_ORDER.REASSIGN_ORDER:
      popupConfirmationAction = handleAssignOrderMutation;
      break;
    case POPUP_TYPE_ORDER.COURIER_INDELIVERY:
      popupConfirmationAction = handleInDeliveryMessage;
      break;
    default:
      popupConfirmationAction = null;
  }

  return (
    <>
      <Popup
        open={activePopup.isOpen}
        activePopup={activePopup}
        fullScreen={false}
        onConfirm={popupConfirmationAction}
        onClose={closeActivePopup}
        cySlug="courier-action-popup"
        isWizardMode={hasNextStep}
      ></Popup>
      <div className={classes.courierCardWrapper}>
      <Card>
        <Card.Body>
          <div className={classes.courierCardBody}>
            <div className={classes.courierCardTitle}>
              <Typography variant="h5" className="heading_s_bold">
                {isGuest ? parseGuestName(firstName) : firstName}
              </Typography>
            </div>
            {/* THIS FIELDS SEEMS PROBELEMTIC */}
            
            {backBy && returnBack?.status === CourierReturnStatusType.Returning ? (
              <JetStatusBadge
                status={EBadgeStatus.RETURNING}
                badgeText={
                  returnBack &&
                  returnBack.status === CourierReturnStatusType.Returning
                    ? t('courier.returningToRestaurant')
                    : t('courier.delivering_none')
                }
              ></JetStatusBadge>
            ) : (
              <JetStatusBadge
                status={!orderPool || !orderPool.totalOrders || passedWaypointsCount === orderPool?.totalOrders ? EBadgeStatus.INVERSE : EBadgeStatus.ACTION}
                badgeText={
                  (!orderPool || !orderPool.totalOrders || passedWaypointsCount === orderPool?.totalOrders)
                    ? t('courier.delivering_none')
                    : t('courier.delivering_multiple', {
                        sequence: orderPool?.orderBeingDelivered,
                        total: orderPool?.totalOrders,
                      })
                }
                
              ></JetStatusBadge>
            )}
            {/* done above */}
            
            {backBy &&
            returnBack?.status === CourierReturnStatusType.Returning ? (
              <Typography variant="body1" className="body_small_bold">
                 {isCRTCountdownActive ? getDistanceDuration(backBy) : <>
                    {t('courier.backBy')} {getTimeFromDate(backBy?.eta)}
                 </>}
              </Typography>
            ) : null}
            <>
              {viewType === CourierViewType.ActionView ? (
                <>
                  {id === assignedCourierId ? (
                    <IconButton
                      classes={{ root: 'details-btn' }}
                      size="medium"
                      aria-label="See details"
                      onClick={() =>
                        orderItemsCTA(
                          id,
                          hash as string,
                          AssignationType.REMOVE
                        )
                      }
                    >
                      <JetFontIcon
                        color={theme.palette.jet?.supportInfoInverse}
                        iconname={JET_FONTICON_ALIASES.CLOSE}
                        size={18}
                      />
                    </IconButton>
                  ) : (
                    <IconButton
                      classes={{ root: 'details-btn' }}
                      size="medium"
                      aria-label="See details"
                      onClick={() =>
                        orderItemsCTA(
                          id,
                          hash as string,
                          isInDelivery
                            ? AssignationType.UPDATE
                            : currentOrderStatus === OrderStatus.Assigned
                            ? AssignationType.REASSIGN
                            : AssignationType.ASSIGN
                        )
                      }
                    >
                      <JetFontIcon
                        color={theme.palette.jet?.supportInfoInverse}
                        iconname={JET_FONTICON_ALIASES.PLUS}
                        size={18}
                      />
                    </IconButton>
                  )}
                </>
              ) : (
                <IconButton
                  classes={{ root: 'details-btn' }}
                  size="medium"
                  aria-label="See details"
                  onClick={() => setSelectedCourier(id)}
                >
                  <JetFontIcon
                    color={theme.palette.jet?.supportInfoInverse}
                    iconname={JET_FONTICON_ALIASES.CHEVRON_RIGHT}
                    size={18}
                  />
                </IconButton>
              )}
            </>
          </div>
        </Card.Body>
      </Card>
      </div>
    </>
  );
};

export default CourierListItem;
